<template>
    <InformeCard
        :id="titulo"
        :name="titulo"
        collapsable="true"
        :title="titulo"
    >
        <ContentOrLoading>
            <div v-if="data" class="row table table-responsive width-responsive">
                <div class="col-12 pr-0">
                    <table class="table table-hover text-nowrap">
                        <thead>
                            <tr>
                                <th>Tipo de abono</th>
                                <th>Tipo de precio</th>
                                <th>Precio</th>
                                <th class="text-center">{{ titulo == 'Ventas' ? 'Vendidas' : 'Devueltas' }}</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody v-if="data">
                            <template v-for="fila in data">
                                <tr :key="fila.id">
                                    <td>{{ fila.area }}</td>
                                    <td>{{ fila.descuento }}</td>
                                    <td>{{ fila.importe | formatear_precio }}</td>
                                    <td class="text-center">{{ fila.total }}</td>
                                    <td>
                                        {{ fila.importe * fila.total | formatear_precio }}
                                    </td>
                                </tr>
                            </template>
                            <tr class="tr-total lightgray-content">
                                <td colspan="3"><strong>TOTAL</strong></td>
                                <td class="text-center">{{ totales.vendidas }}</td>
                                <td>{{ totales.importe | formatear_precio }}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="5">
                                    <LoaderComponent/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ContentOrLoading>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['lista_id', 'fecha_inicio', 'fecha_fin', 'titulo'],
        data() {
            return {
                loading: false,
                data: null
            }
        },
        methods: {
            getData() {
                this.loading = true;
                const url = this.titulo == 'Devoluciones' ? 'back.abonos.informe.devoluciones' : 'back.abonos.informe.ventas'

                const params = {
                    filters : {},
                    lista_id: this.lista_id
                };

                if (this.fecha_inicio && this.fecha_fin) {
                    params.filters.fecha_inicio = this.fecha_inicio;
                    params.filters.fecha_fin = this.fecha_fin;
                
                }

                this.$store.dispatch(this.config.getVuexAlias(url), params).then(res => {
                    this.data = res.data.data;
                }).finally(() => this.loading = false);
            },
        },
        computed: {
            totales() {
                var totales = {
                    importe: 0,
                    vendidas: 0
                };

                if (this.data) {
                    this.data.forEach(element => {
                        totales.importe += element.importe * element.total;
                        totales.vendidas += element.total;
                    });
                }

                return totales;
            },
        },
        created() {
            this.getData();
        },
        components: {
            InformeCard
        }
    }
</script>

<style scoped>
     @media (max-width: 700px) {
        .width-responsive {
            width: 295px;
        }
     }
</style>